module.exports = __webpack_public_path__ + "static/el-ombu-y-el-pajaro-azul_40x30in-2013-1fe5a0afafe7c53c0377aa9ad93044c8.jpg";